import { v4 as uuidv4 } from "uuid";
import { ParsedRowType } from "../../types";

export const createEmptyRow = (baseId?: string): ParsedRowType => ({
  id: uuidv4(),
  textValue: "",
  textValueConvert: "",
  textError: "",
  start: undefined,
  end: undefined,
  typeId: undefined,
  toTypeId: undefined,
  parameterType: "",
  description: "",
  baseId,
  isDeviceId: false,
});

export const findInsertIndex = (parsed: ParsedRowType[], parentId: string): number => {
  const parentIndex = parsed.findIndex(p => p.id === parentId);
  if (parentIndex === -1) return parsed.length;

  let insertIndex = parentIndex + 1;
  while (insertIndex < parsed.length && parsed[insertIndex].baseId === parentId) {
    insertIndex++;
  }
  return insertIndex;
};

export const getDependentIds = (parsed: ParsedRowType[], baseId: string): string[] => {
  const result = new Set<string>();

  const visit = (id: string) => {
    parsed.forEach(item => {
      if (item.baseId === id && !result.has(item.id)) {
        result.add(item.id);
        visit(item.id);
      }
    });
  };

  visit(baseId);
  return Array.from(result);
};

export const recomputeTextValue = (parsed: ParsedRowType[], itemId: string): void => {
  const row = parsed.find(p => p.id === itemId);
  if (!row?.baseId) return;

  const base = parsed.find(p => p.id === row.baseId);
  if (!base?.textValueConvert) {
    row.textValue = "";
    return;
  }

  const { start, end } = row;
  if (typeof start === "number" && typeof end === "number" && start > 0 && end >= start && end <= base.textValueConvert.length) {
    row.textValue = base.textValueConvert.substring(start - 1, end);
  } else {
    row.textValue = "";
  }
};

export const computeTextValue = (
  start: number | undefined,
  end: number | undefined,
  baseId: string | undefined,
  parsed: ParsedRowType[],
  rawData: string
): string => {
  const source = baseId ? String(parsed.find(p => p.id === baseId)?.textValueConvert || "") : rawData;
  if (typeof start === "number" && typeof end === "number" && start > 0 && end > 0 && start <= end && end <= source.length) {
    return source.substring(start - 1, end);
  }
  return "";
};
